import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState(result === "success" ? "checking" : "cancel");

  useEffect(() => {
    if (result !== "success") return;
    const isPaypal = params.get("provider") === "paypal";
    const url = isPaypal ? `/paypal/status/${params.get("subscription_id")}` : `/payments/status/${params.get("session_id")}`;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(url);
        if (data.payment_status === "paid") {
          setState("paid");
          refresh();
          return;
        }
      } catch {
        /* retry */
      }
      if (++tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [result, params, refresh]);

  const view = {
    checking: [Loader2, "Stiamo confermando il pagamento…", "Ci vuole qualche secondo.", "animate-spin text-[#1E3A8A]"],
    paid: [CheckCircle2, "Benvenuto in Burocrazy Pro", "Ora hai documenti illimitati.", "text-emerald-600"],
    timeout: [Loader2, "Pagamento in elaborazione", "Riceverai la conferma a breve. Controlla nelle Impostazioni.", "text-slate-500"],
    cancel: [XCircle, "Pagamento annullato", "Nessun addebito effettuato.", "text-slate-500"],
  }[state];
  const [Icon, title, desc, cls] = view;

  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="payment-result">
      <div className="max-w-md w-full rounded-3xl border bg-white p-10 text-center fade-up">
        <Icon className={`h-12 w-12 mx-auto ${cls}`} />
        <h1 className="mt-4 text-2xl font-semibold" data-testid="payment-result-title">{title}</h1>
        <p className="mt-2 text-slate-600">{desc}</p>
        <Button asChild className="mt-8 rounded-full" data-testid="payment-back-btn"><Link to="/app">Torna a Burocrazy</Link></Button>
      </div>
    </div>
  );
}
